import moment from 'moment';
import { isEqual } from 'lodash';
import { createQueryParams } from '@nexio/emvio-util-app';

import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { goToUrl } from '../Table/tableActions';

export const TRANSACTIONS_LOAD = 'TRANSACTIONS/TRANSACTIONS_LOAD';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS/TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_FAILURE = 'TRANSACTIONS/TRANSACTIONS_FAILURE';

export const TRANSACTIONS_TOTAL_LOAD = 'TRANSACTIONS/TRANSACTIONS_TOTAL_LOAD';
export const TRANSACTIONS_TOTAL_SUCCESS = 'TRANSACTIONS/TRANSACTIONS_TOTAL_SUCCESS';
export const TRANSACTIONS_TOTAL_FAILURE = 'TRANSACTIONS/TRANSACTIONS_TOTAL_FAILURE';

export const TRANSACTIONS_COUNT_SUCCESS = 'TRANSACTIONS/TRANSACTIONS_COUNT_SUCCESS';
export const TRANSACTIONS_COUNT_LOAD = 'TRANSACTIONS/TRANSACTIONS_COUNT_LOAD';
export const TRANSACTIONS_COUNT_FAILURE = 'TRANSACTIONS/TRANSACTIONS_COUNT_FAILURE';

export const TRANSACTIONS_CARDTYPES_LOAD = 'TRANSACTIONS/TRANSACTIONS_CARDTYPES_LOAD';
export const TRANSACTIONS_CARDTYPES_SUCCESS = 'TRANSACTIONS/TRANSACTIONS_CARDTYPES_SUCCESS';
export const TRANSACTIONS_CARDTYPES_FAILURE = 'TRANSACTIONS/TRANSACTIONS_CARDTYPES_FAILURE';

export const TRANSACTIONS_SEARCH_LOAD = 'TRANSACTIONS/SEARCH_LOAD';
export const TRANSACTIONS_SEARCH_SUCCESS = 'TRANSACTIONS/SEARCH_SUCCESS';
export const TRANSACTIONS_SEARCH_FAILURE = 'TRANSACTIONS/SEARCH_FAILURE';
export const TRANSACTIONS_CLEAR_SEARCH = 'TRANSACTIONS/CLEAR_SEARCH';

export const fetchUrl = `${config.transactionsApiUrl}`;

export function selectTransaction(history, transaction, newTab) {
    goToUrl(history, `/transaction/${transaction.id}`, newTab);
}

export function isTransactionNegative(amount, type) {
    return amount < 0 || isEqual(type.toLowerCase(), 'refund');
}

export function getTransactionsFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTIONS_FAILURE
    };
}

export function getTransactionsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, TRANSACTIONS_SUCCESS, 'transactions');
}

export function getTransactionsCountSuccessActionCreator(count) {
    return {
        transactionsCount: count,
        type: TRANSACTIONS_COUNT_SUCCESS
    };
}

export function getTransactionsCountFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTIONS_COUNT_FAILURE
    };
}

export function getTransactionsTotalFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTIONS_TOTAL_FAILURE
    };
}

export function getTransactionsTotalSuccessActionCreator(total) {
    return {
        transactionsTotal: total,
        type: TRANSACTIONS_TOTAL_SUCCESS
    };
}

export function getTransactionsCardTypesFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTIONS_CARDTYPES_FAILURE
    };
}

export function getTransactionsCardTypesSuccessActionCreator(cardTypes) {
    return {
        cardTypes,
        type: TRANSACTIONS_CARDTYPES_SUCCESS
    };
}

export function getTransactions(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getTransactionsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: TRANSACTIONS_LOAD,
        successActionTypeOrCreator: getTransactionsSuccessActionCreator
    };
}

export function getTransactionsCount(filters, merchantIds) {
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters,
        merchantIds
    });

    return {
        failureActionTypeOrCreator: getTransactionsCountFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/count${queryParamsString}`
        },
        loadActionTypeOrCreator: TRANSACTIONS_COUNT_LOAD,
        successActionTypeOrCreator: getTransactionsCountSuccessActionCreator
    };
}

export function getTransactionsTotal(filters, merchantIds) {
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters,
        merchantIds
    });

    return {
        failureActionTypeOrCreator: getTransactionsTotalFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/total${queryParamsString}`
        },
        loadActionTypeOrCreator: TRANSACTIONS_TOTAL_LOAD,
        successActionTypeOrCreator: getTransactionsTotalSuccessActionCreator
    };
}

export function getTransactionsCardTypes() {
    return {
        failureActionTypeOrCreator: getTransactionsCardTypesFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/paymentTypes`
        },
        loadActionTypeOrCreator: TRANSACTIONS_CARDTYPES_LOAD,
        successActionTypeOrCreator: getTransactionsCardTypesSuccessActionCreator
    };
}

export function searchTransactionsSuccessActionCreator(result = []) {
    return {
        transactions: result,
        type: TRANSACTIONS_SEARCH_SUCCESS
    };
}

export function searchTransactionsFailureActionCreator(error) {
    return {
        error,
        type: TRANSACTIONS_SEARCH_FAILURE
    };
}

export function searchTransactions(searchQuery, merchantIds) {
    let queryParamsString = `?search=${searchQuery}`;
    if (merchantIds) {
        queryParamsString += `&merchantIds=${merchantIds}`;
    }

    return {
        failureActionTypeOrCreator: searchTransactionsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/search${queryParamsString}`
        },
        loadActionTypeOrCreator: TRANSACTIONS_SEARCH_LOAD,
        successActionTypeOrCreator: searchTransactionsSuccessActionCreator
    };
}

export function clearSearchTransactions() {
    return {
        type: TRANSACTIONS_CLEAR_SEARCH
    };
}

export function goToBatchOfTransactions(achDetailId, history, newTab, date) {
    const calculatedEndDate = moment().isBefore(moment(date).add(1, 'week'))
        ? moment().format('YYYY-MM-DD')
        : moment(date).add(1, 'week').format('YYYY-MM-DD');
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters: [
            {
                id: 'achDetailId',
                value: achDetailId
            },
            {
                id: 'startDate',
                value: moment(date).subtract(2, 'month').format('YYYY-MM-DD')
            },
            {
                id: 'endDate',
                value: calculatedEndDate
            }
        ],
        page: 0,
        pageSize: 10,
        sorters: []
    });

    goToUrl(history, `/transaction${queryParamsString}`, newTab);
}

export function getBatchOfTransactionsLink(achDetailId, startDate) {
    const calculatedEndDate = moment().isBefore(moment(startDate).add(1, 'month'))
        ? moment().format('YYYY-MM-DD')
        : moment(startDate).add(1, 'month').format('YYYY-MM-DD');
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters: [
            {
                id: 'achDetailId',
                value: achDetailId
            },
            {
                id: 'startDate',
                value: moment(startDate).subtract(1, 'month').format('YYYY-MM-DD')
            },
            {
                id: 'endDate',
                value: calculatedEndDate
            }
        ],
        page: 0,
        pageSize: 10,
        sorters: []
    });

    return `/transaction${queryParamsString}`;
}

export function getTransactionsPaymentIdLink(paymentId) {
    const queryParamsString = createQueryParams({
        filters: [
            {
                id: 'plugin.originalId',
                value: paymentId
            }
        ],
        page: 0,
        pageSize: 10,
        sorters: []
    });

    return `/transaction${queryParamsString}`;
}
